import Axios from 'axios';

const RESOURCE = '/api/unsubscribe';

export default {
  /**
   * Send a single unsubscribe request.
   * @param {string} email - The email to unsubscribe.
   */
  singleUnsubscribe(email: string) {
    return Axios.post(`${RESOURCE}/`, { email });
  },

  /**
   * Send a bulk unsubscribe request.
   * @param {string[]} emails - The emails to unsubscribe.
   */
  bulkUnsubscribe(emails: string[]) {
    return Axios.post(`${RESOURCE}/bulk`, { emails });
  },

  /**
   * Get unsubscribes for an organization with pagination.
   * @param {number} page - The page number.
   * @param {number} limit - The number of items per page.
   */
  getOrgUnsubscribes(page: number = 1, limit: number = 10) {
    return Axios.get(`${RESOURCE}/page`, {
      params: { page, limit },
    });
  },
};
